/* maré · card stock tag follows the chosen metal swatch */
(function () {
  if (window.__mareStock) return; window.__mareStock = true;
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-m-swatch]'); if (!dot) return;
    var card = dot.closest('[data-m-card]'); if (!card) return;
    var tag = card.querySelector('[data-m-card-stock]'); if (!tag) return;
    var max = parseInt(tag.getAttribute('data-max'), 10) || 15;
    var raw = dot.getAttribute('data-stock');
    var n = raw === null ? NaN : parseInt(raw, 10);
    var ok = n > 0 && n <= max;
    var b = tag.querySelector('[data-n]');
    if (ok && b) b.textContent = n + ' left';
    tag.hidden = !ok;
    var badge = card.querySelector('[data-m-card-badge]');
    if (badge) badge.hidden = ok;
  }, true);
})();
